/** Default name for the session cookie name / local storage key */
export const SESSION_TOKEN_KEY = 'DS';
/** Default name for the refresh local storage key */
export const REFRESH_TOKEN_KEY = 'DSR';
